export default __webpack_public_path__ + "static/media/5.f49a4c58.png";